/**
 * Created by daniesy on 09/11/2016.
 */
require("babel-polyfill");
const d3 = require('d3');



export default class Chart {
    constructor(options) {
        this.cachedWidth = window.innerWidth;

        this.options = options;
        this.data = [];
        this.names = [];
        this.classes = [];

        this.interval = 0;

        this.minX = 0;
        this.maxX = 0;
        this.minY = 100;
        this.maxY = 100;

        this.onAnswerClicked = (d, i) => {};
        this.detectResize();
    }

    detectResize(options) {
      let timeout = false,
          delta = 300;

        window.addEventListener('resize', (event) => {
          if (timeout === false) {
              timeout = true;
              setTimeout(() => {
                timeout = false;
                this.reset();
              }, delta);
          }
        });
    }

    reset() {
        if(window.innerWidth === this.cachedWidth) {
          return;
        }
        this.cachedWidth = window.innerWidth;

        this.stopInterval();
        this.chartContent.transition();
    }

    addLine(data, name, className) {
        this.data.push(data);
        this.names.push(name);
        this.classes.push(className);

        this.findMaxX(data);
        this.findMinX(data);
        this.findMaxY(data);
        this.findMinY(data);

        console.log(data);

        return this;
    }

    findMaxX(data) {
        this.maxX = data[data.length - 1].date;
    }

    findMinX(data) {
        this.minX = data[0].date;
    }

    findMaxY(data) {
        this.maxY = Math.max(this.maxY, data.reduce(Chart.maxReduceRecipe, 0));
    }

    findMinY(data) {
        this.minY = Math.min(this.minY, data.reduce(Chart.minReduceRecipe, 100));
    }

    static maxReduceRecipe(carry, data) {
        return data.price > carry ? data.price : carry
    }

    static minReduceRecipe(carry, data) {
        return data.price < carry ? data.price : carry
    }

    draw(hasCourtain = true) {
        this.chartSvg = d3.select(this.options.element)
        // .attr("style", `width: ${this.options.width}px; height: ${this.options.height}px`)
            .append("svg")
            .attr("width", this.options.width)
            .attr("height", this.options.height);

        this.chartContent = this.chartSvg.append("g")
            .attr("transform", "translate(" + (this.options.margins.left || 0) + "," + (this.options.margins.top || 0) + ")");

        this.width = this.options.width - (this.options.margins.left || 0) - (this.options.margins.right || 0);
        this.height = this.options.height - (this.options.margins.top || 0) - (this.options.margins.bottom || 0);

        this.scaleX = d3.scaleTime().range([0, this.width]);
        this.scaleY = d3.scaleLinear().range([this.height, 0]);

        this.scaleX.domain(this.domainX);
        this.scaleY.domain(this.domainY);

        this.axisX = d3.axisBottom(this.scaleX).tickSize(2, 4).ticks(6);

        this.chartContent.append('g')
          .attr('class', 'axis_x')
          .attr('transform', `translate(0, ${this.height})`)
          .call(this.axisX.tickFormat(d3.timeFormat(this.options.dateFormat)))
          .selectAll("text")
          .attr("y", 5)
          .attr("x", 0);
        // this.chartContent.append('g').attr('class', 'axis_y').call(this.axisY);

        let chartLine = d3.line()
            .x(d => this.scaleX(d.date))
            .y(d => this.scaleY(d.price));

        this.data.forEach((element, index) => {
            this.chartContent.append('path')
                .data([element])
                .attr('class', `line line--${this.classes[index]}`)
                .attr('d', chartLine)
        });

        this.addInteractivity();

        if(hasCourtain) {
            this.addCourtain();
        }

        this.addGridLines();
        this.addLegend();

        return this;
    }

    overlaps(elem1, elem2) {
      let rect1 = elem1.getBoundingClientRect(),
          rect2 = elem2.getBoundingClientRect();

      return !(rect1.right < rect2.left ||
                rect1.left > rect2.right ||
                rect1.bottom < rect2.top ||
                rect1.top > rect2.bottom)
    }

    fixOverlapping(elem, elem2) {
      const newY = elem.offsetTop - elem2.offsetHeight - 20;
      return newY > 0 ? newY : elem.offsetTop + elem2.offsetHeight + 20;
    }

    drawEvents(events) {
        this.events = events;
        this.eventElements = d3.select(this.options.element)
        .append('div')
        .attr('class', 'events')
        .selectAll('p')
        .data(events)
        .enter()
        .append('p')
        .attr('id', (d, i) => "event-"+d.formattedDate)
        .attr('class', 'event')
        .style('left', (d, i) => {
          let left = this.scaleX(d.date);
          if (left + 220 < this.width) {
            return `${d.x = left}px`;
          }
          return `${d.x = this.width - 220}px`
          // `${d.x = this.scaleX(d.date)}px`
        })
        .style('top', (d, i) => `${this.scaleY(d.value)-150}px`)
        .attr('data-date', (d, i) => d.formattedDate)
        .text((d, i) => d.event);

        // Fix overlapping
        const self = this;
        this.eventElements.each(function(d, i) {
              if (this.previousSibling && self.overlaps(this, this.previousSibling)) {
                  this.style.top = self.fixOverlapping(this.previousSibling, this)+"px";
              }
        });
    }

    drawAnswers(answers) {
      this.answers = answers;
      this.answerElements = d3.select(this.options.element)
      .append('div')
      .attr('class', 'answers')
      .selectAll('div')
      .data(answers)
      .enter()
      .append('div')
      .attr('id', (d, i) => "answer-"+d.formattedDate)
      .style('left', (d, i) => `${this.scaleX(d.date)}px`)
      .style('top', (d, i) => `${this.findPos(0, this.scaleX(d.date)).y}px`)
      .attr('class', (d, i) => d.correct ? "answer answer--correct" : "answer answer--incorrect")
      .attr('data-title', (d, i) => d.title)
      .attr('data-index', (d, i) => i + 1)
      .on("click", (d, i) => this.onAnswerClicked(d, i))
      .on("touchstart", function(d, i) { d3.select(this).classed("answer--touched", true) })
      .on("touchend", function(d, i) { d3.select(this).classed("answer--touched", false) });
    }

    removeAnswers() {
        this.answerElements.remove();
    }

    addLegend() {
        let legend = this.chartContent
            .append('g')
            .attr('class', 'legends')
            .attr('transform', "translate(15, 0)")
            .selectAll('g')
            .data(this.names)
            .enter()
            .append('g')
            .attr('class', (d, i) => `legend legend--${this.classes[i]}`);

        legend.append('circle')
            .attr('cy', 3)
            .attr('cx', (d, i) => i * 200 + 3)
            .attr('r', 5)
            .attr('class', 'legend__circle');

        legend.append('text')
            .attr('y', 8)
            .attr('x', (d, i) => i * 200 + 15)
            .text((d, i) => this.names[i]);
    }

    findPos(i, x) {
        let lines = document.getElementsByClassName('line');
        let beginning = 0,
            end = lines[i].getTotalLength(),
            target = null,
            pos = null;

        while (true) {
            target = Math.floor((beginning + end) / 2);
            pos = lines[i].getPointAtLength(target);
            if ((target === end || target === beginning) && pos.x !== x) {
                break;
            }
            if (pos.x > x) {
                end = target;
            } else if (pos.x < x) {
                beginning = target;
            } else {
                break; // position found
            }
        }
        return pos;
    }

    addInteractivity() {
        const that = this,
            mouseGroup = this.chartContent.append('g').attr('class', 'mouse-over-effects');
        // Vertical line
        mouseGroup.append('path')
            .attr('class', 'vertical-line')
            .style('stroke', '#ccc')
            .style('stroke-width', '1px')
            .style('opacity', 0);

        let mousePerLine = mouseGroup.selectAll('.mouse-per-line')
            .data(that.data)
            .enter()
            .append('g')
            .attr('class', (d, i) => `mouse-per-line ${this.classes[i]}`);

        mousePerLine.append('circle')
            .attr('cy', 0)
            .attr('r', 5)
            .attr('class', (d, i) => `circle circle--${this.classes[i]}`)
            .style('stroke-width', '1.5px')
            .style('opacity', 0);

        mousePerLine.append('text')
            .attr('transform', 'translate(-40,3)');

        mouseGroup.append('this.chartContent:rect')
            .attr('width', that.width)
            .attr('height', that.height)
            .attr('fill', 'none')
            .attr('pointer-events', 'all')
            .on('mouseout', function () {
                that.chartContent.select('.vertical-line').style('opacity', 0);
                d3.selectAll('.mouse-per-line circle').style('opacity', 0);
                d3.selectAll('.mouse-per-line text').style('opacity', 0);
            })
            .on('mouseover', function () {
                that.chartContent.select('.vertical-line').style('opacity', 1);
                d3.selectAll('.mouse-per-line circle').style('opacity', 1);
                d3.selectAll('.mouse-per-line text').style('opacity', 1);
            })
            .on('mousemove', function () {
                let mouse = d3.mouse(this);
                that.chartContent.select('.vertical-line')
                    .attr('d', () => 'M' + mouse[0] + ',' + that.height + ',' + mouse[0] + ',' + 0);

                d3.selectAll('.mouse-per-line')
                    .attr('transform', function (d, i) {
                        let pos = that.findPos(i, mouse[0]);
                        d3.select(this).select('text')
                            .text(that.scaleY.invert(pos.y).toFixed(2));

                        return 'translate(' + mouse[0] + ',' + pos.y + ')';
                    });
            })
    }

    addGridLines() {
        let that = this;

        function make_y_gridlines() {
            return d3.axisLeft(that.scaleY).ticks(Math.max(that.options.height/50, 2));
        }

        this.chartContent.append("g")
            .attr("class", "grid")
            .call(make_y_gridlines()
                .tickSize(-this.width)
                .tickFormat(d => d)
            )
    }

    addCourtain() {
        this.courtain = this.chartContent
            .append('rect')
            .attr('x', -1 * this.width)
            .attr('y', -1 * this.height + 1)
            .attr('height', this.height)
            .attr('width', this.width)
            .attr('class', 'curtain')
            .attr('transform', 'rotate(180)')
            .style('fill', '#ffffff');
    }

    resetCourtain() {
        this.courtain.attr('width', this.width);
    }

    resetEvents() {
      this.eventElements.each(function(d, i) {
            d3.select(this).attr('class', 'event');
      });
    }

    animateToDate(dateString, duration, callback) {
        return new Promise((resolve) => {
            let date = d3.timeParse("%d-%m-%Y")(dateString);
            this.startEventInterval();
            let t = this.chartContent.transition()
                .duration(duration)
                .ease(d3.easeLinear)
                .on('end', () => {
                    this.stopInterval();
                    resolve();
                 })
                .select('rect.curtain')
                .attr('width', this.width - this.scaleX(date))
        });
    }

    animate(duration = 3000, withAnswers = false) {
        return new Promise((resolve) => {

          // if(withAnswers) { this.startAnswerInterval(); }

          let t = this.chartContent.transition()
              .duration(duration)
              .ease(d3.easeLinear)
              .on('end', () => {
                  this.stopInterval();
                  resolve();
              })
              .select('rect.curtain')
              .attr('width', 0)
        });
    }

    startEventInterval() {
        this.timer = setInterval(() => {
          this.verifyEvent();
        }, 333);
    }

    startAnswerInterval() {
        this.timer = setInterval(() => {
          this.verifyAnswer();
        }, 333);
    }

    stopInterval() {
        clearInterval(this.timer);
    }

    verifyEvent() {
      const x = -this.courtain.attr("x")-this.courtain.attr('width');
      const date = new Date(this.scaleX.invert(x));

      for (let event of this.events) {

        if(event.date.getTime() > date.getTime()) {
          return;
        }

        d3.select(`#event-${event.formattedDate}`).attr('class', 'event event--shown');
      }
    }

    verifyAnswer() {
      const x = -this.courtain.attr("x")-this.courtain.attr('width');
      const date = new Date(this.scaleX.invert(x));

      for (let answer of this.answers) {
        if(answer.date.getTime() > date.getTime()) {
          return;
        }

        document.querySelector(`#answer-${answer.formattedDate}`).classList.add('answer--shown');
      }
    }

    toggleBlurred() {
      let blurred = !this.chartSvg.classed('blurred');
      this.chartSvg.classed('blurred', blurred);
      d3.select(this.options.element).select('.events').classed('blurred', blurred);
    }

    pauseEvents() {
      d3.selectAll('.event--shown').classed('event--paused', true);
    }

    resumeEvents() {
      d3.selectAll('.event--shown').classed('event--paused', false);
    }

    toggleFinished() {
        this.chartSvg.classed('finished', !this.chartSvg.classed('finished'));
    }

    get domainX() {
        return [this.minX, this.maxX];
    }

    get domainY() {
        return [this.minY * 0.9, this.maxY * 1.05];
    }
}



// WEBPACK FOOTER //
// ./src/js/chart.js